<template>
  <div>
    <div>
      <div class="header-stats" v-if="!isLoading && testState.id">
        <div class="stat-col stat-col--nav">
          <bg-select
            @input="handleSelectChange"
            :options="participants"
            :value="dropdownValue"
          ></bg-select>
        </div>
        <div class="stat-col">
          <div class="stat-header">Time to complete</div>
          <div class="stat-value stat-value--inline">
            <span>{{ timeToComplete }}</span>
            <bg-tooltip
              v-if="hasTtcMismatch"
              :dark="true"
              :info="true"
              placement="top"
            >
              <template #content>
                Recording length can differ from time to complete because video and mouse data are captured by separate processes. Minor differences are expected.
              </template>
            </bg-tooltip>
          </div>
        </div>
        <div class="stat-col" v-if="data.total_clicks">
          <div class="stat-header">Clicks</div>
          <div class="stat-value">{{ data.total_clicks }}</div>
        </div>
        <div class="stat-col">
          <div class="stat-header">Age</div>
          <div class="stat-value">{{ this.data.demographic.age }}</div>
        </div>
        <div class="stat-col">
          <div class="stat-header">Education</div>
          <div class="stat-value stat-value--upper">
            {{ data.demographic.education }}
          </div>
        </div>
        <div class="stat-col">
          <div class="stat-header">Gender</div>
          <div class="stat-value">{{ data.demographic.gender }}</div>
        </div>
      </div>
      <bg-heatmap v-if="!isLoading" :data="data" />
    </div>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
  </div>
</template>

<style scoped>
.header-stats {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.stat-col {
  margin-right: 50px;
  display: flex;
  flex-direction: column;
}

.stat-header {
  font-weight: 300;
}

.stat-value {
  font-weight: 700;
  font-size: 24px;
  color: var(--bg-color-text-secondary);
}

.stat-value--upper {
  text-transform: uppercase;
}

.stat-col--nav {
  flex-direction: row;
}

.navButtons {
  display: flex;
}

.navButtons a {
  margin-right: 10px;
}

.navButtons a:first-child {
  margin-left: 15px;
}

.heatmapjs-container {
  width: 1000px;
  height: 500px;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgSelect from "@/components/bg-select";
import BgNavigation from "@/components/bg-navigation";
import API from "@/api";
import BgHeatmap from "@/components/bg-heatmap";
import BgLoader from "@/components/bg-loader";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "participant-video",
  components: {
    BgHeatmap,
    BgLoader,
    BgSelect,
    BgNavigation,
    BgTooltip: () => import('@/components/bg-tooltip'),
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      isLoading: true,
      data: null,
      participants: [],
      hasTtcMismatch: false,
      loadedVideoDuration: null,
    };
  },
  mounted() {
    this.getTest();
    API.test.getTest(this.$route.params.id).then((res) => {
      this.participants = res.participants.map((p) => {
        return {
          value: p.id,
          label: `Participant ${p.id}`,
        };
      });
      this.dropdownValue = {
        value: this.$route.params.participantId,
        label: `Participant ${this.$route.params.participantId}`,
      };
    });
  },
  methods: {
    getTest() {
      API.test
        .getParticipant(this.$route.params.id, this.$route.params.participantId)
        .then((res) => {
          this.isLoading = false;
          this.data = res;
          this.dropdownValue = {
            value: this.$route.params.participantId,
            label: `Participant ${this.$route.params.participantId}`,
          };
        });
    },
    handleSelectChange(val) {
      this.$router.replace(
        `/test/${this.$route.params.id}/participant/${val.value}/recording`
      );
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.participantId !== from.params.participantId) {
        this.isLoading = true;
        this.getTest();
      }
    },
  },
  computed: {
    timeToComplete(data) {
      const startTime = moment(this.data.started_at);
      const endTime = moment(this.data.ended_at);
      const diff = endTime.diff(startTime);
      return moment(diff).format("mm:ss");
    },
    nextButtonLink() {
      const newIndex =
        this.$route.params.participantId >= this.participants.length
          ? 1
          : Number(this.$route.params.participantId) + 1;

      return `/test/${this.testState.id}/participant/${newIndex}/recording`;
    },
    backButtonLink() {
      const newIndex =
        this.$route.params.participantId == 1
          ? this.participants.length
          : Number(this.$route.params.participantId) - 1;

      return `/test/${this.testState.id}/participant/${newIndex}/recording`;
    },
    ...mapState({
      testState: (state) => state.test,
    }),
  },
};
</script>

<style scoped>
.stat-value--inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
</style>
